export default __webpack_public_path__ + "static/media/key-icon.0845d7db.svg";